import { useLoaderData, useOutlet } from "react-router-dom";
import { StoreData } from "./types/StoreData";
import "./css/tailwind.css";

export default function Root() {
  const storeData = useLoaderData() as StoreData;

  const outlet = useOutlet(storeData);

  return (
    <section className="flex min-h-screen flex-col items-center justify-center">
      {outlet ?? <p>Nothing to see here.</p>}
    </section>
  );
}
